import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { BookmarksService } from 'src/app/bookmarks/bookmarks.service';
import { ModulesThumbnailService } from 'src/app/modules/modules-thumbnail.service';
import { ContentType } from 'src/app/story/models/content-type.enum';
import { ViewService } from '../../view.service';

declare const localBaseDirectory: string;

@Component({
  selector: 'app-view-ondemand',
  templateUrl: './view-ondemand.component.html',
  styleUrls: ['./view-ondemand.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewOndemandComponent implements OnInit {

  @Input()
  contentId: string;

  @Input()
  contentType: ContentType;

  constructor(
    private viewService: ViewService,
    private modulesThumbnailService: ModulesThumbnailService,
    private bookmarksService: BookmarksService
  ) { }

  ngOnInit(): void {
  }

  handleClick() {
    this.viewService.toggleOnDemand(false);
  }

  getThumbnailUrl () {
    if (this.contentType === ContentType.Bookmark) {
      return this.bookmarksService.getIndexThumbnail(this.contentId);
    } else {
      return this.modulesThumbnailService.getStoryIndexThumbnail(this.contentId);
    }
  }

  getPoweredByUrl() {
    const directory = (typeof localBaseDirectory === 'undefined') ? '' : localBaseDirectory;
    return directory + 'assets/images/powered-by-biodigital-logo.svg';
  }

}
